import { BaseResponseSchema } from '../../schemas.js';
import { containerSlotScanJobIdParamSchema, initiateContainerSlotScanJobRequestSchema, initiateContainerSlotScanJobResponseSchema, retryContainerSlotScanOcrQuerySchema, retryContainerSlotScanOcrRequestSchema, } from '../../container-slot-scan.schemas.js';
import { containerSlotScanSlotIdParamSchema, fingerprintOverrideBodySchema, fingerprintOverrideResponseSchema, } from '../../job-workflow.schemas.js';
/** REST contract for `insight-api/src/routes/tenant/container-slot-scans.routes.ts`. */
export const containerSlotScansContract = {
    initiate: {
        method: 'POST',
        path: '/tenant/container-slot-scans',
        body: initiateContainerSlotScanJobRequestSchema,
        response: initiateContainerSlotScanJobResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'jobId',
        errorMessage: 'Failed to initiate container slot scan',
    },
    retryOcr: {
        method: 'POST',
        path: '/tenant/container-slot-scans/:jobId/retry-ocr',
        pathParams: containerSlotScanJobIdParamSchema,
        query: retryContainerSlotScanOcrQuerySchema,
        body: retryContainerSlotScanOcrRequestSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to retry OCR',
    },
    setFingerprintOverride: {
        method: 'PUT',
        path: '/tenant/container-slot-scans/:jobId/slots/:slotNumber/fingerprint-override',
        pathParams: containerSlotScanSlotIdParamSchema,
        body: fingerprintOverrideBodySchema,
        response: fingerprintOverrideResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to set fingerprint override',
    },
};
//# sourceMappingURL=container-slot-scans.contract.js.map